
import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Generate More Leads for Your Automotive Business",
    points: [
      "Run click-to-WhatsApp ads on social media to attract potential buyers.",
      "Connect Interakt with your CRM or Google Sheets to organize lead data for follow-ups.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_2.png",
  },
  {
    heading: "Drive New Vehicle Sales with WhatsApp",
    points: [
      "Use WhatsApp broadcasts to highlight the latest car models at your dealership.",
      "Share stunning photos, videos, and special offers to encourage purchases.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_3.png",
  },
  {
    heading: "Schedule Test Drives and Showroom Visits Easily",
    points: [
      "Let customers book test drives and visits via WhatsApp for a hassle-free experience.",
      "Demonstrate vehicle features and benefits during test drives to boost sales.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_4.png",
  },
  {
    heading: "Simplify Service Bookings with WhatsApp",
    points: [
      "Promote repair, rental, and maintenance services using WhatsApp broadcasts.",
      "Use interactive messages to accept bookings and send reminders for appointments.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_5.png",
  },
  {
    heading: "Encourage Used Car Sales Through WhatsApp",
    points: [
      "Inform customers they can sell their used cars through your business via WhatsApp.",
      "Gather details, make offers, and arrange pickups all within the chat platform.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_6.png",
  },
  {
    heading: "Provide Expert Advice on WhatsApp",
    points: [
      "Offer quick answers to post-purchase and service questions using automations.",
      "Help customers with mileage, maintenance, and other concerns to build trust.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_7.png",
  },
  {
    heading: "Collect Reviews to Build Trust",
    points: [
      "Send automated requests for feedback after services to highlight your expertise.",
      "Encourage reviews on Google, Facebook, or your website to enhance credibility.",
    ],
    buttonText: "Meta Policy for automotive business",
    buttonLink:"https://www.facebook.com/business/help/1510143265745613?id=378777162599537",

    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_8.png",
  },
  {
    heading: "Share Exciting News and Launches",
    points: [
      "Announce new services, showrooms, events, or vehicle launches via WhatsApp broadcasts.",
      "Keep customers informed to position your brand as innovative and reliable.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_9.png",
  },
  {
    heading: "Manage Documents Seamlessly on WhatsApp",
    points: [
      "Request and share documents like IDs, licenses, and insurance via secure chats.",
      "Make it easy for customers to submit paperwork for purchases or services.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_10.png",
  },
  {
    heading: "Educate and Engage Your Customers",
    points: [
      "Share valuable tips and insights related to their purchases or services.",
      "Position yourself as a knowledgeable partner by offering helpful advice on WhatsApp.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_11.png",
  },
];

const Automativecycle = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center text-center h-64 bg-gradient-to-r from-pink-200 via-pink-100 to-pink-300 px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-800 max-w-5xl">How to Grow Your Automotive Business with WhatsApp</h1>
        <div className="w-16 h-1 bg-gray-500 my-4 rounded-full"></div>
        <p className="text-lg text-gray-600 max-w-4xl mt-2 px-2">From promoting deals to scheduling services, WhatsApp Business API makes customer communication smooth and boosts your automotive business growth.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Automativecycle;